import PropTypes from 'prop-types';
import { TableCell, Table, TableHead, TableRow, TableBody, Box } from '@material-ui/core';

// styles for the table
const styles = {
  tableRow: {
    '&:last-child td, &:last-child th': { border: 0 }
  }
};

VMDiskSummary.propTypes = {
  vm: PropTypes.object
};
export default function VMDiskSummary({ vm }) {
  return (
    <Box data-testid="disk-summary">
      <Table size="small" aria-label="Disk Details">
        <TableHead>
          <TableRow>
            <TableCell>Image Source</TableCell>
            <TableCell align="right">Disk Size</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {vm.disks.map((disk) => (
            <TableRow key={vm.name} sx={styles.tableRow}>
              <TableCell>{disk.image !== '' ? disk.image : 'Blank Disk'}</TableCell>
              <TableCell align="right">{disk.diskSize.toString()}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
}
